
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_FULL_PAGE"] = $af2b0e533822f413$export$6a8e7521883fbbdb;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("fvUfW"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("19LHz"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("2adyH"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("k2Q99"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("5gm5i"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("cnAEf"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("74ish"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("ic8m1"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("bqdDX"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fgNXR"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("ddfY9"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("8gOrM"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["FullPageForgeApp"] = $02976f123c8f8e25$export$b8ad4f58faf0ae;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("fvUfW", function(module, exports) {

let $b4b5638da46c1b05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4b5638da46c1b05$var$load("2YffH"),
    $b4b5638da46c1b05$var$load("8Kivm"),
    $b4b5638da46c1b05$var$load("cf5vC"),
    $b4b5638da46c1b05$var$load("b99Vc"),
    $b4b5638da46c1b05$var$load("fyZ5h"),
    $b4b5638da46c1b05$var$load("bXhvu"),
    $b4b5638da46c1b05$var$load("iQ0Jm"),
    $b4b5638da46c1b05$var$load("65Hz8"),
    $b4b5638da46c1b05$var$load("7zr7w"),
    $b4b5638da46c1b05$var$load("7GmzD"),
    $b4b5638da46c1b05$var$load("h4Nf7"),
    $b4b5638da46c1b05$var$load("7f9Fz"),
    $b4b5638da46c1b05$var$load("6p14c"),
    $b4b5638da46c1b05$var$load("ie88R"),
    $b4b5638da46c1b05$var$load("49GA1"),
    $b4b5638da46c1b05$var$load("32K9i"),
    $b4b5638da46c1b05$var$load("aeEUI"),
    $b4b5638da46c1b05$var$load("iXzmH"),
    $b4b5638da46c1b05$var$load("65c4i"),
    $b4b5638da46c1b05$var$load("6wr18"),
    $b4b5638da46c1b05$var$load("kjZZD"),
    $b4b5638da46c1b05$var$load("5fSdR"),
    $b4b5638da46c1b05$var$load("3TTZL"),
    $b4b5638da46c1b05$var$load("37ldp"),
    $b4b5638da46c1b05$var$load("awqCy"),
    $b4b5638da46c1b05$var$load("kHOMt"),
    $b4b5638da46c1b05$var$load("hhss7"),
    $b4b5638da46c1b05$var$load("Wowvf"),
    $b4b5638da46c1b05$var$load("ffEVr"),
    $b4b5638da46c1b05$var$load("5465r"),
    $b4b5638da46c1b05$var$load("fkY2m"),
    $b4b5638da46c1b05$var$load("let0D"),
    $b4b5638da46c1b05$var$load("dSgGr"),
    $b4b5638da46c1b05$var$load("c5uOY"),
    $b4b5638da46c1b05$var$load("4uIGS"),
    $b4b5638da46c1b05$var$load("97s9d"),
    $b4b5638da46c1b05$var$load("hUIij"),
    $b4b5638da46c1b05$var$load("6Up0b"),
    $b4b5638da46c1b05$var$load("lnKog"),
    $b4b5638da46c1b05$var$load("7EorR"),
    $b4b5638da46c1b05$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("19LHz", function(module, exports) {

let $0d7ba249ce7adc5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d7ba249ce7adc5a$var$load("2YffH"),
    $0d7ba249ce7adc5a$var$load("8Kivm"),
    $0d7ba249ce7adc5a$var$load("cf5vC"),
    $0d7ba249ce7adc5a$var$load("b99Vc"),
    $0d7ba249ce7adc5a$var$load("fyZ5h"),
    $0d7ba249ce7adc5a$var$load("bXhvu"),
    $0d7ba249ce7adc5a$var$load("iQ0Jm"),
    $0d7ba249ce7adc5a$var$load("65Hz8"),
    $0d7ba249ce7adc5a$var$load("7zr7w"),
    $0d7ba249ce7adc5a$var$load("7GmzD"),
    $0d7ba249ce7adc5a$var$load("h4Nf7"),
    $0d7ba249ce7adc5a$var$load("7f9Fz"),
    $0d7ba249ce7adc5a$var$load("6p14c"),
    $0d7ba249ce7adc5a$var$load("ie88R"),
    $0d7ba249ce7adc5a$var$load("49GA1"),
    $0d7ba249ce7adc5a$var$load("32K9i"),
    $0d7ba249ce7adc5a$var$load("aeEUI"),
    $0d7ba249ce7adc5a$var$load("iXzmH"),
    $0d7ba249ce7adc5a$var$load("65c4i"),
    $0d7ba249ce7adc5a$var$load("6wr18"),
    $0d7ba249ce7adc5a$var$load("kjZZD"),
    $0d7ba249ce7adc5a$var$load("5fSdR"),
    $0d7ba249ce7adc5a$var$load("3TTZL"),
    $0d7ba249ce7adc5a$var$load("37ldp"),
    $0d7ba249ce7adc5a$var$load("awqCy"),
    $0d7ba249ce7adc5a$var$load("kHOMt"),
    $0d7ba249ce7adc5a$var$load("hhss7"),
    $0d7ba249ce7adc5a$var$load("Wowvf"),
    $0d7ba249ce7adc5a$var$load("ffEVr"),
    $0d7ba249ce7adc5a$var$load("5465r"),
    $0d7ba249ce7adc5a$var$load("fkY2m"),
    $0d7ba249ce7adc5a$var$load("let0D"),
    $0d7ba249ce7adc5a$var$load("dSgGr"),
    $0d7ba249ce7adc5a$var$load("c5uOY"),
    $0d7ba249ce7adc5a$var$load("4uIGS"),
    $0d7ba249ce7adc5a$var$load("97s9d"),
    $0d7ba249ce7adc5a$var$load("hUIij"),
    $0d7ba249ce7adc5a$var$load("6Up0b"),
    $0d7ba249ce7adc5a$var$load("lnKog"),
    $0d7ba249ce7adc5a$var$load("7EorR"),
    $0d7ba249ce7adc5a$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("2adyH", function(module, exports) {

let $19370869a24710eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $19370869a24710eb$var$load("2YffH"),
    $19370869a24710eb$var$load("8Kivm"),
    $19370869a24710eb$var$load("cf5vC"),
    $19370869a24710eb$var$load("b99Vc"),
    $19370869a24710eb$var$load("fyZ5h"),
    $19370869a24710eb$var$load("bXhvu"),
    $19370869a24710eb$var$load("iQ0Jm"),
    $19370869a24710eb$var$load("65Hz8"),
    $19370869a24710eb$var$load("7zr7w"),
    $19370869a24710eb$var$load("7GmzD"),
    $19370869a24710eb$var$load("h4Nf7"),
    $19370869a24710eb$var$load("7f9Fz"),
    $19370869a24710eb$var$load("6p14c"),
    $19370869a24710eb$var$load("ie88R"),
    $19370869a24710eb$var$load("49GA1"),
    $19370869a24710eb$var$load("32K9i"),
    $19370869a24710eb$var$load("aeEUI"),
    $19370869a24710eb$var$load("iXzmH"),
    $19370869a24710eb$var$load("65c4i"),
    $19370869a24710eb$var$load("6wr18"),
    $19370869a24710eb$var$load("kjZZD"),
    $19370869a24710eb$var$load("5fSdR"),
    $19370869a24710eb$var$load("3TTZL"),
    $19370869a24710eb$var$load("37ldp"),
    $19370869a24710eb$var$load("awqCy"),
    $19370869a24710eb$var$load("kHOMt"),
    $19370869a24710eb$var$load("hhss7"),
    $19370869a24710eb$var$load("Wowvf"),
    $19370869a24710eb$var$load("ffEVr"),
    $19370869a24710eb$var$load("5465r"),
    $19370869a24710eb$var$load("fkY2m"),
    $19370869a24710eb$var$load("let0D"),
    $19370869a24710eb$var$load("dSgGr"),
    $19370869a24710eb$var$load("c5uOY"),
    $19370869a24710eb$var$load("4uIGS"),
    $19370869a24710eb$var$load("97s9d"),
    $19370869a24710eb$var$load("hUIij"),
    $19370869a24710eb$var$load("6Up0b"),
    $19370869a24710eb$var$load("lnKog"),
    $19370869a24710eb$var$load("7EorR"),
    $19370869a24710eb$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("k2Q99", function(module, exports) {

let $e97c71cb5231cf52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e97c71cb5231cf52$var$load("2YffH"),
    $e97c71cb5231cf52$var$load("cf5vC"),
    $e97c71cb5231cf52$var$load("b99Vc"),
    $e97c71cb5231cf52$var$load("fyZ5h"),
    $e97c71cb5231cf52$var$load("bXhvu"),
    $e97c71cb5231cf52$var$load("7zr7w"),
    $e97c71cb5231cf52$var$load("7GmzD"),
    $e97c71cb5231cf52$var$load("h4Nf7"),
    $e97c71cb5231cf52$var$load("7f9Fz"),
    $e97c71cb5231cf52$var$load("49GA1"),
    $e97c71cb5231cf52$var$load("32K9i"),
    $e97c71cb5231cf52$var$load("aeEUI"),
    $e97c71cb5231cf52$var$load("iXzmH"),
    $e97c71cb5231cf52$var$load("65c4i"),
    $e97c71cb5231cf52$var$load("6wr18"),
    $e97c71cb5231cf52$var$load("kjZZD"),
    $e97c71cb5231cf52$var$load("5fSdR"),
    $e97c71cb5231cf52$var$load("3TTZL"),
    $e97c71cb5231cf52$var$load("37ldp"),
    $e97c71cb5231cf52$var$load("awqCy"),
    $e97c71cb5231cf52$var$load("kHOMt"),
    $e97c71cb5231cf52$var$load("hhss7"),
    $e97c71cb5231cf52$var$load("Wowvf"),
    $e97c71cb5231cf52$var$load("ffEVr"),
    $e97c71cb5231cf52$var$load("5465r"),
    $e97c71cb5231cf52$var$load("fkY2m"),
    $e97c71cb5231cf52$var$load("let0D"),
    $e97c71cb5231cf52$var$load("dSgGr"),
    $e97c71cb5231cf52$var$load("c5uOY"),
    $e97c71cb5231cf52$var$load("4uIGS"),
    $e97c71cb5231cf52$var$load("hUIij"),
    $e97c71cb5231cf52$var$load("97s9d"),
    $e97c71cb5231cf52$var$load("7EorR"),
    $e97c71cb5231cf52$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("5gm5i", function(module, exports) {

let $3d4f93e453268110$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d4f93e453268110$var$load("2YffH"),
    $3d4f93e453268110$var$load("cf5vC"),
    $3d4f93e453268110$var$load("b99Vc"),
    $3d4f93e453268110$var$load("fyZ5h"),
    $3d4f93e453268110$var$load("bXhvu"),
    $3d4f93e453268110$var$load("7zr7w"),
    $3d4f93e453268110$var$load("7GmzD"),
    $3d4f93e453268110$var$load("h4Nf7"),
    $3d4f93e453268110$var$load("7f9Fz"),
    $3d4f93e453268110$var$load("49GA1"),
    $3d4f93e453268110$var$load("32K9i"),
    $3d4f93e453268110$var$load("aeEUI"),
    $3d4f93e453268110$var$load("iXzmH"),
    $3d4f93e453268110$var$load("65c4i"),
    $3d4f93e453268110$var$load("6wr18"),
    $3d4f93e453268110$var$load("kjZZD"),
    $3d4f93e453268110$var$load("5fSdR"),
    $3d4f93e453268110$var$load("3TTZL"),
    $3d4f93e453268110$var$load("37ldp"),
    $3d4f93e453268110$var$load("awqCy"),
    $3d4f93e453268110$var$load("kHOMt"),
    $3d4f93e453268110$var$load("hhss7"),
    $3d4f93e453268110$var$load("Wowvf"),
    $3d4f93e453268110$var$load("ffEVr"),
    $3d4f93e453268110$var$load("5465r"),
    $3d4f93e453268110$var$load("fkY2m"),
    $3d4f93e453268110$var$load("let0D"),
    $3d4f93e453268110$var$load("dSgGr"),
    $3d4f93e453268110$var$load("c5uOY"),
    $3d4f93e453268110$var$load("4uIGS"),
    $3d4f93e453268110$var$load("hUIij"),
    $3d4f93e453268110$var$load("97s9d"),
    $3d4f93e453268110$var$load("7EorR"),
    $3d4f93e453268110$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("cnAEf", function(module, exports) {

let $90340f8ef784816e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90340f8ef784816e$var$load("2YffH"),
    $90340f8ef784816e$var$load("cf5vC"),
    $90340f8ef784816e$var$load("b99Vc"),
    $90340f8ef784816e$var$load("fyZ5h"),
    $90340f8ef784816e$var$load("bXhvu"),
    $90340f8ef784816e$var$load("7zr7w"),
    $90340f8ef784816e$var$load("7GmzD"),
    $90340f8ef784816e$var$load("h4Nf7"),
    $90340f8ef784816e$var$load("7f9Fz"),
    $90340f8ef784816e$var$load("49GA1"),
    $90340f8ef784816e$var$load("32K9i"),
    $90340f8ef784816e$var$load("aeEUI"),
    $90340f8ef784816e$var$load("iXzmH"),
    $90340f8ef784816e$var$load("65c4i"),
    $90340f8ef784816e$var$load("6wr18"),
    $90340f8ef784816e$var$load("kjZZD"),
    $90340f8ef784816e$var$load("5fSdR"),
    $90340f8ef784816e$var$load("3TTZL"),
    $90340f8ef784816e$var$load("37ldp"),
    $90340f8ef784816e$var$load("awqCy"),
    $90340f8ef784816e$var$load("kHOMt"),
    $90340f8ef784816e$var$load("hhss7"),
    $90340f8ef784816e$var$load("Wowvf"),
    $90340f8ef784816e$var$load("ffEVr"),
    $90340f8ef784816e$var$load("5465r"),
    $90340f8ef784816e$var$load("fkY2m"),
    $90340f8ef784816e$var$load("let0D"),
    $90340f8ef784816e$var$load("dSgGr"),
    $90340f8ef784816e$var$load("c5uOY"),
    $90340f8ef784816e$var$load("4uIGS"),
    $90340f8ef784816e$var$load("hUIij"),
    $90340f8ef784816e$var$load("97s9d"),
    $90340f8ef784816e$var$load("7EorR"),
    $90340f8ef784816e$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("74ish", function(module, exports) {

let $525738f03d9bc6a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $525738f03d9bc6a9$var$load("2YffH"),
    $525738f03d9bc6a9$var$load("cf5vC"),
    $525738f03d9bc6a9$var$load("b99Vc"),
    $525738f03d9bc6a9$var$load("fyZ5h"),
    $525738f03d9bc6a9$var$load("bXhvu"),
    $525738f03d9bc6a9$var$load("7zr7w"),
    $525738f03d9bc6a9$var$load("7GmzD"),
    $525738f03d9bc6a9$var$load("h4Nf7"),
    $525738f03d9bc6a9$var$load("7f9Fz"),
    $525738f03d9bc6a9$var$load("49GA1"),
    $525738f03d9bc6a9$var$load("32K9i"),
    $525738f03d9bc6a9$var$load("aeEUI"),
    $525738f03d9bc6a9$var$load("iXzmH"),
    $525738f03d9bc6a9$var$load("65c4i"),
    $525738f03d9bc6a9$var$load("6wr18"),
    $525738f03d9bc6a9$var$load("kjZZD"),
    $525738f03d9bc6a9$var$load("5fSdR"),
    $525738f03d9bc6a9$var$load("3TTZL"),
    $525738f03d9bc6a9$var$load("37ldp"),
    $525738f03d9bc6a9$var$load("awqCy"),
    $525738f03d9bc6a9$var$load("kHOMt"),
    $525738f03d9bc6a9$var$load("hhss7"),
    $525738f03d9bc6a9$var$load("Wowvf"),
    $525738f03d9bc6a9$var$load("ffEVr"),
    $525738f03d9bc6a9$var$load("5465r"),
    $525738f03d9bc6a9$var$load("fkY2m"),
    $525738f03d9bc6a9$var$load("let0D"),
    $525738f03d9bc6a9$var$load("dSgGr"),
    $525738f03d9bc6a9$var$load("c5uOY"),
    $525738f03d9bc6a9$var$load("4uIGS"),
    $525738f03d9bc6a9$var$load("97s9d"),
    $525738f03d9bc6a9$var$load("hUIij"),
    $525738f03d9bc6a9$var$load("6Up0b"),
    $525738f03d9bc6a9$var$load("lnKog"),
    $525738f03d9bc6a9$var$load("7EorR"),
    $525738f03d9bc6a9$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("ic8m1", function(module, exports) {

let $d3efd3fa1065b92d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3efd3fa1065b92d$var$load("2YffH"),
    $d3efd3fa1065b92d$var$load("cf5vC"),
    $d3efd3fa1065b92d$var$load("b99Vc"),
    $d3efd3fa1065b92d$var$load("fyZ5h"),
    $d3efd3fa1065b92d$var$load("bXhvu"),
    $d3efd3fa1065b92d$var$load("65Hz8"),
    $d3efd3fa1065b92d$var$load("7zr7w"),
    $d3efd3fa1065b92d$var$load("7GmzD"),
    $d3efd3fa1065b92d$var$load("h4Nf7"),
    $d3efd3fa1065b92d$var$load("7f9Fz"),
    $d3efd3fa1065b92d$var$load("6p14c"),
    $d3efd3fa1065b92d$var$load("ie88R"),
    $d3efd3fa1065b92d$var$load("49GA1"),
    $d3efd3fa1065b92d$var$load("32K9i"),
    $d3efd3fa1065b92d$var$load("aeEUI"),
    $d3efd3fa1065b92d$var$load("iXzmH"),
    $d3efd3fa1065b92d$var$load("65c4i"),
    $d3efd3fa1065b92d$var$load("6wr18"),
    $d3efd3fa1065b92d$var$load("kjZZD"),
    $d3efd3fa1065b92d$var$load("5fSdR"),
    $d3efd3fa1065b92d$var$load("3TTZL"),
    $d3efd3fa1065b92d$var$load("37ldp"),
    $d3efd3fa1065b92d$var$load("dTsOE"),
    $d3efd3fa1065b92d$var$load("awqCy"),
    $d3efd3fa1065b92d$var$load("kHOMt"),
    $d3efd3fa1065b92d$var$load("hhss7"),
    $d3efd3fa1065b92d$var$load("Wowvf"),
    $d3efd3fa1065b92d$var$load("ffEVr"),
    $d3efd3fa1065b92d$var$load("5465r"),
    $d3efd3fa1065b92d$var$load("fkY2m"),
    $d3efd3fa1065b92d$var$load("let0D"),
    $d3efd3fa1065b92d$var$load("dSgGr"),
    $d3efd3fa1065b92d$var$load("c5uOY"),
    $d3efd3fa1065b92d$var$load("4uIGS"),
    $d3efd3fa1065b92d$var$load("97s9d"),
    $d3efd3fa1065b92d$var$load("hUIij"),
    $d3efd3fa1065b92d$var$load("6Up0b"),
    $d3efd3fa1065b92d$var$load("lnKog"),
    $d3efd3fa1065b92d$var$load("7EorR"),
    $d3efd3fa1065b92d$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("bqdDX", function(module, exports) {

let $850cb4c06fbb940a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $850cb4c06fbb940a$var$load("2YffH"),
    $850cb4c06fbb940a$var$load("cf5vC"),
    $850cb4c06fbb940a$var$load("b99Vc"),
    $850cb4c06fbb940a$var$load("fyZ5h"),
    $850cb4c06fbb940a$var$load("bXhvu"),
    $850cb4c06fbb940a$var$load("65Hz8"),
    $850cb4c06fbb940a$var$load("7zr7w"),
    $850cb4c06fbb940a$var$load("7GmzD"),
    $850cb4c06fbb940a$var$load("h4Nf7"),
    $850cb4c06fbb940a$var$load("7f9Fz"),
    $850cb4c06fbb940a$var$load("6p14c"),
    $850cb4c06fbb940a$var$load("ie88R"),
    $850cb4c06fbb940a$var$load("49GA1"),
    $850cb4c06fbb940a$var$load("32K9i"),
    $850cb4c06fbb940a$var$load("aeEUI"),
    $850cb4c06fbb940a$var$load("iXzmH"),
    $850cb4c06fbb940a$var$load("65c4i"),
    $850cb4c06fbb940a$var$load("6wr18"),
    $850cb4c06fbb940a$var$load("kjZZD"),
    $850cb4c06fbb940a$var$load("5fSdR"),
    $850cb4c06fbb940a$var$load("3TTZL"),
    $850cb4c06fbb940a$var$load("37ldp"),
    $850cb4c06fbb940a$var$load("dTsOE"),
    $850cb4c06fbb940a$var$load("awqCy"),
    $850cb4c06fbb940a$var$load("kHOMt"),
    $850cb4c06fbb940a$var$load("hhss7"),
    $850cb4c06fbb940a$var$load("Wowvf"),
    $850cb4c06fbb940a$var$load("ffEVr"),
    $850cb4c06fbb940a$var$load("5465r"),
    $850cb4c06fbb940a$var$load("fkY2m"),
    $850cb4c06fbb940a$var$load("let0D"),
    $850cb4c06fbb940a$var$load("dSgGr"),
    $850cb4c06fbb940a$var$load("c5uOY"),
    $850cb4c06fbb940a$var$load("4uIGS"),
    $850cb4c06fbb940a$var$load("97s9d"),
    $850cb4c06fbb940a$var$load("hUIij"),
    $850cb4c06fbb940a$var$load("6Up0b"),
    $850cb4c06fbb940a$var$load("lnKog"),
    $850cb4c06fbb940a$var$load("7EorR"),
    $850cb4c06fbb940a$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fgNXR", function(module, exports) {

let $b1df1b89570b628f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1df1b89570b628f$var$load("2YffH"),
    $b1df1b89570b628f$var$load("cf5vC"),
    $b1df1b89570b628f$var$load("b99Vc"),
    $b1df1b89570b628f$var$load("fyZ5h"),
    $b1df1b89570b628f$var$load("bXhvu"),
    $b1df1b89570b628f$var$load("7zr7w"),
    $b1df1b89570b628f$var$load("7GmzD"),
    $b1df1b89570b628f$var$load("h4Nf7"),
    $b1df1b89570b628f$var$load("7f9Fz"),
    $b1df1b89570b628f$var$load("49GA1"),
    $b1df1b89570b628f$var$load("32K9i"),
    $b1df1b89570b628f$var$load("aeEUI"),
    $b1df1b89570b628f$var$load("iXzmH"),
    $b1df1b89570b628f$var$load("65c4i"),
    $b1df1b89570b628f$var$load("6wr18"),
    $b1df1b89570b628f$var$load("kjZZD"),
    $b1df1b89570b628f$var$load("5fSdR"),
    $b1df1b89570b628f$var$load("3TTZL"),
    $b1df1b89570b628f$var$load("37ldp"),
    $b1df1b89570b628f$var$load("awqCy"),
    $b1df1b89570b628f$var$load("kHOMt"),
    $b1df1b89570b628f$var$load("hhss7"),
    $b1df1b89570b628f$var$load("Wowvf"),
    $b1df1b89570b628f$var$load("ffEVr"),
    $b1df1b89570b628f$var$load("5465r"),
    $b1df1b89570b628f$var$load("fkY2m"),
    $b1df1b89570b628f$var$load("let0D"),
    $b1df1b89570b628f$var$load("dSgGr"),
    $b1df1b89570b628f$var$load("c5uOY"),
    $b1df1b89570b628f$var$load("4uIGS"),
    $b1df1b89570b628f$var$load("hUIij"),
    $b1df1b89570b628f$var$load("97s9d"),
    $b1df1b89570b628f$var$load("7EorR"),
    $b1df1b89570b628f$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("ddfY9", function(module, exports) {

let $99e8e06e39ae8781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $99e8e06e39ae8781$var$load("2YffH"),
    $99e8e06e39ae8781$var$load("cf5vC"),
    $99e8e06e39ae8781$var$load("b99Vc"),
    $99e8e06e39ae8781$var$load("fyZ5h"),
    $99e8e06e39ae8781$var$load("bXhvu"),
    $99e8e06e39ae8781$var$load("7zr7w"),
    $99e8e06e39ae8781$var$load("7GmzD"),
    $99e8e06e39ae8781$var$load("h4Nf7"),
    $99e8e06e39ae8781$var$load("7f9Fz"),
    $99e8e06e39ae8781$var$load("49GA1"),
    $99e8e06e39ae8781$var$load("32K9i"),
    $99e8e06e39ae8781$var$load("aeEUI"),
    $99e8e06e39ae8781$var$load("iXzmH"),
    $99e8e06e39ae8781$var$load("65c4i"),
    $99e8e06e39ae8781$var$load("6wr18"),
    $99e8e06e39ae8781$var$load("kjZZD"),
    $99e8e06e39ae8781$var$load("5fSdR"),
    $99e8e06e39ae8781$var$load("3TTZL"),
    $99e8e06e39ae8781$var$load("37ldp"),
    $99e8e06e39ae8781$var$load("awqCy"),
    $99e8e06e39ae8781$var$load("kHOMt"),
    $99e8e06e39ae8781$var$load("hhss7"),
    $99e8e06e39ae8781$var$load("Wowvf"),
    $99e8e06e39ae8781$var$load("ffEVr"),
    $99e8e06e39ae8781$var$load("5465r"),
    $99e8e06e39ae8781$var$load("fkY2m"),
    $99e8e06e39ae8781$var$load("let0D"),
    $99e8e06e39ae8781$var$load("dSgGr"),
    $99e8e06e39ae8781$var$load("c5uOY"),
    $99e8e06e39ae8781$var$load("4uIGS"),
    $99e8e06e39ae8781$var$load("97s9d"),
    $99e8e06e39ae8781$var$load("hUIij"),
    $99e8e06e39ae8781$var$load("6Up0b"),
    $99e8e06e39ae8781$var$load("lnKog"),
    $99e8e06e39ae8781$var$load("7EorR"),
    $99e8e06e39ae8781$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("8gOrM", function(module, exports) {

let $6056f315f1afa75d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6056f315f1afa75d$var$load("2YffH"),
    $6056f315f1afa75d$var$load("cf5vC"),
    $6056f315f1afa75d$var$load("b99Vc"),
    $6056f315f1afa75d$var$load("fyZ5h"),
    $6056f315f1afa75d$var$load("bXhvu"),
    $6056f315f1afa75d$var$load("7zr7w"),
    $6056f315f1afa75d$var$load("7GmzD"),
    $6056f315f1afa75d$var$load("h4Nf7"),
    $6056f315f1afa75d$var$load("7f9Fz"),
    $6056f315f1afa75d$var$load("49GA1"),
    $6056f315f1afa75d$var$load("32K9i"),
    $6056f315f1afa75d$var$load("aeEUI"),
    $6056f315f1afa75d$var$load("iXzmH"),
    $6056f315f1afa75d$var$load("65c4i"),
    $6056f315f1afa75d$var$load("6wr18"),
    $6056f315f1afa75d$var$load("kjZZD"),
    $6056f315f1afa75d$var$load("5fSdR"),
    $6056f315f1afa75d$var$load("3TTZL"),
    $6056f315f1afa75d$var$load("37ldp"),
    $6056f315f1afa75d$var$load("awqCy"),
    $6056f315f1afa75d$var$load("kHOMt"),
    $6056f315f1afa75d$var$load("hhss7"),
    $6056f315f1afa75d$var$load("Wowvf"),
    $6056f315f1afa75d$var$load("ffEVr"),
    $6056f315f1afa75d$var$load("5465r"),
    $6056f315f1afa75d$var$load("fkY2m"),
    $6056f315f1afa75d$var$load("let0D"),
    $6056f315f1afa75d$var$load("dSgGr"),
    $6056f315f1afa75d$var$load("c5uOY"),
    $6056f315f1afa75d$var$load("4uIGS"),
    $6056f315f1afa75d$var$load("97s9d"),
    $6056f315f1afa75d$var$load("hUIij"),
    $6056f315f1afa75d$var$load("6Up0b"),
    $6056f315f1afa75d$var$load("lnKog"),
    $6056f315f1afa75d$var$load("7EorR"),
    $6056f315f1afa75d$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("al4VD", function(module, exports) {
/* ContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $dAYOx = parcelRequire("dAYOx");


var $c4sKh = parcelRequire("c4sKh");


var $1lhEF = parcelRequire("1lhEF");

var $2Fndw = parcelRequire("2Fndw");

function $97c789ddabfb1332$var$_defineProperty(e, r, t) {
    return (r = $97c789ddabfb1332$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $97c789ddabfb1332$var$_toPropertyKey(t) {
    var i = $97c789ddabfb1332$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $97c789ddabfb1332$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97c789ddabfb1332$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $97c789ddabfb1332$var$labelContainerStyles = (0, $ecnYn.xcss)({
    flex: 2
});
const $97c789ddabfb1332$var$badgeContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
class $97c789ddabfb1332$var$ContentToolsItemClass extends (0, $42omo.PureComponent) {
    render() {
        const { label: label, onClick: onClick, url: url, id: id, className: className, isDisabled: isDisabled, innerRef: innerRef, testId: testId, onMouseEnter: onMouseEnter, shouldHighlight: shouldHighlight, elemBefore: elemBefore, interactionName: interactionName } = this.props;
        const contentToolsItem = // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onMouseEnter,
            "data-test-id": id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default // @ts-ignore DropdownItem doesn't declare support for className
        ), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            href: url ?? undefined,
            testId: (testId || id) ?? undefined,
            onClick: onClick,
            isDisabled: isDisabled,
            elemBefore: elemBefore,
            UNSAFE_shouldDisableRouterLink: true,
            interactionName: interactionName
        }, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97c789ddabfb1332$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            xcss: $97c789ddabfb1332$var$labelContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: innerRef,
            "data-test-id": "content-item-label" // webitems sometimes have html (for keyboard shortcuts)
            ,
            dangerouslySetInnerHTML: {
                __html: label.replace(/[0-9]/g, '').replace(/[{()}]/g, '')
            }
        })), label.replace(/\D/g, '').length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $97c789ddabfb1332$var$badgeContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, label.replace(/\D/g, ''))) : null) : label));
        if (shouldHighlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingInline: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
            radius: 4
        }, contentToolsItem)));
        return contentToolsItem;
    }
}
$97c789ddabfb1332$var$_defineProperty($97c789ddabfb1332$var$ContentToolsItemClass, "propTypes", {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    linkComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).elementType,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    shouldHighlight: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).elementType
});
$97c789ddabfb1332$var$_defineProperty($97c789ddabfb1332$var$ContentToolsItemClass, "defaultProps", {
    onMouseEnter: ()=>{}
});
const $97c789ddabfb1332$export$c2ed13e36e284c55 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97c789ddabfb1332$var$ContentToolsItemClass, {
        innerRef: ref,
        ...props
    }));
$97c789ddabfb1332$export$c2ed13e36e284c55.displayName = 'ContentToolsItem';
module.exports["ContentToolsItem"] = $97c789ddabfb1332$export$c2ed13e36e284c55;

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.d04a3e41.js.map
